import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Spinner } from "@/components/kit";
import ActivityList from "@/components/ActivityList";

export default function Activity() {
  const { gid } = useAuth();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/groups/${gid}/activity`, { params: { limit: 300 } }).then((r) => setItems(r.data));
  }, [gid]);
  return (
    <div className="pb-6">
      <PageHeader title="Activity log" subtitle="Every material action, newest first" />
      {items ? <ActivityList items={items} testid="activity-page-list" /> : <Spinner />}
    </div>
  );
}
